<template lang='pug'>
el-dialog(:title="editingTeam && editingTeam.id ? '编辑团队' : '创建团队'", :visible="teamFormVisible" :before-close="hideTeamForm")
    el-form(:model="form" ref="form")
        el-form-item(label="代号", label-width="80px")
            el-input(v-model="form.name")
        el-form-item(label="名称", label-width="80px")
            el-input(v-model="form.displayName")
        el-form-item(label="管理员" label-width="80px")
            el-select.add-member(
                v-model="form.teamAdmin"
                filterable
                clearable
                remote
                placeholder="请输入管理员账号关键词"
                :remote-method="listOrgMembers"
                :loading="loading")
                //- @change="addTeamMember")
                el-option(
                    v-for="item in orgMembers"
                    :key="item.user.name"
                    :label="item.user.displayName"
                    :value="item.user.name")
                    span(style="float: left") {{ item.user.displayName }}
                    span(style="float: right; color: #8492a6; font-size: 13px") {{ item.user.name }}
        el-form-item(label="邮箱", label-width="80px")
            el-input(v-model="form.email")
    .dialog-footer(slot="footer")
        el-button(@click="hideTeamForm") 取 消
        el-button(type="primary", @click="submit", :loading="loading") 确 定
</template>

<script>
// @ is an alias to /src
import {
    getUserOrgsAPI,
    listOrgMembersAPI,
    createTeamAPI,
    updateTeamByIDAPI
} from "@/services";
const defaultForm = {
    name: "",
    displayName: "",
    email: null,
    teamAdmin: ""
};
export default {
    name: "team-form",
    props: ["teamFormVisible", "editingTeam", "orgname"],
    data() {
        return {
            loading: false,
            search: "",
            orgMembers: [],
            form: Object.assign({}, defaultForm)
        };
    },
    methods: {
        /**
         * Backend Service API Func Wrapper
         */
        async listOrgMembers(keyword) {
            this.loading = true;
            let orgs;
            try {
                const res1 = await getUserOrgsAPI({
                    name: localStorage.getItem("account")
                });
                if (res1.status === 200 && res1.data.length) {
                    orgs = res1.data;
                } else {
                    throw err;
                }
                const res2 = await listOrgMembersAPI(orgs[0].org.name, {
                    name: keyword,
                    limit: 0
                });
                if (res2.status === 200) {
                    this.orgMembers = res2.data.data;
                } else {
                    throw err;
                }
            } catch (err) {
                console.log("获取组织成员列表失败");
                this.$message.error("服务器开小差了，请尝试重新操作");
            } finally {
                this.loading = false;
            }
        },
        async createTeam() {
            this.loading = true;
            try {
                const res = await createTeamAPI(
                    this.orgname,
                    this._.pickBy(this.form, this._.identity)
                );
                if (res.status === 201) {
                    this.$message({
                        message: "保存成功",
                        type: "success"
                    });
                } else {
                    throw err;
                }
            } catch (err) {
                this.$message.error("服务器开小差了，请尝试重新操作");
            } finally {
                this.loading = false;
            }
        },
        async updateTeamByID() {
            this.loading = true;
            try {
                const res = await updateTeamByIDAPI(
                    this._.pickBy(this.form, this._.identity)
                );
                if (res.status === 200) {
                    this.$message.success("保存成功");
                } else {
                    throw err;
                }
            } catch (err) {
                this.$message.error("服务器开小差了，请尝试重新操作");
            } finally {
                this.loading = false;
            }
        },
        /**
         * UI Control
         */
        hideTeamForm() {
            this.$emit("hideTeamForm");
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    console.log("error submit!!");
                    return false;
                }
                if (this.teamFormVisible && this.editingTeam) {
                    this.updateTeamByID();
                } else {
                    this.createTeam();
                }
                this.$emit("refreshTeams");
                this.form = Object.assign({}, defaultForm);
                this.hideTeamForm();
            });
        }
    },
    watch: {
        teamFormVisible(val) {
            if (val && this.editingTeam) {
                this.form = Object.assign({}, defaultForm, this.editingTeam);
            } else if (val && !this.editingTeam) {
                this.form = Object.assign({}, defaultForm);
            }
        }
    },
    mounted() {}
};
</script>
<style lang="stylus" scoped>
.add-member {
    width: 100%;
    margin-top: -50px;
    margin-bottom: 10px;
}</style>